import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

import { isDefined } from '../../utils/types';
import { Text } from '../Typography';

export interface NoRecordsOverlayCustomMessage {
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

interface NoRecordsOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  customMessage?: NoRecordsOverlayCustomMessage;
}

export function NoRecordsOverlay(props: NoRecordsOverlayProps) {
  const { customMessage, ...restProps } = props;
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        height: '100%',
        padding: 4,
      }}
      {...restProps}
    >
      <Stack
        spacing={2}
        sx={{
          alignItems: 'center',
        }}
      >
        <Stack gap={1} alignItems="center">
          <Text variant="heading4" bold>
            {customMessage?.title ?? 'No items found'}
          </Text>
          {isDefined(customMessage?.description) && (
            <Text variant="body2">{customMessage.description}</Text>
          )}
        </Stack>
        {isDefined(customMessage?.action) ? customMessage.action : null}
      </Stack>
    </Stack>
  );
}
